import React from "react";

const DoAndPayment = ({ amount, onClose, isDark }) => {
  return (
    <div
      className="cw-slideIn"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
      }}
    >
      {/* 🔥 HEADER (MATCHING YOUR PANELS) */}
      <div
        style={{
          padding: "22px 20px 18px",
          borderLeft: "4px solid #6366f1",
          background: isDark
            ? "linear-gradient(135deg, rgba(99,102,241,0.15), transparent)"
            : "linear-gradient(135deg, rgba(99,102,241,0.08), transparent)",
          borderBottom: isDark
            ? "1px solid rgba(255,255,255,0.05)"
            : "1px solid rgba(99,102,241,0.08)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 30, marginBottom: 6 }}>💳</div>
            <div
              className="cw-syne"
              style={{ fontSize: 17, fontWeight: 800, color: "#6366f1" }}
            >
              D/O & Payment
            </div>
            <div className="cw-sub" style={{ fontSize: 13 }}>
              Complete your payment securely
            </div>
          </div>

          {/* ❌ CLOSE BUTTON */}
          <button
            onClick={onClose}
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              cursor: "pointer",
              background: isDark
                ? "rgba(255,255,255,0.08)"
                : "rgba(99,102,241,0.1)",
              border: "none",
              color: isDark ? "#fff" : "#6366f1",
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* 🔥 BODY */}
      <div style={{ padding: 20 }}>

        {/* 💰 AMOUNT CARD */}
        <div
          style={{
            borderRadius: 16,
            padding: 20,
            marginBottom: 20,
            background: isDark
              ? "rgba(255,255,255,0.04)"
              : "rgba(99,102,241,0.05)",
            border: "1px solid rgba(99,102,241,0.2)",
            textAlign: "center",
          }}
        >
          <div
            className="cw-muted"
            style={{ fontSize: 12, marginBottom: 8 }}
          >
            Estimated Amount
          </div>

          <div
            className="cw-syne"
            style={{
              fontSize: 28,
              fontWeight: 900,
              color: "#6366f1",
            }}
          >
            ₹ {amount || 1}
          </div>
        </div>

        {/* 🚀 PAY BUTTON */}
        <button
          style={{
            width: "100%",
            padding: "14px",
            borderRadius: 12,
            border: "none",
            fontSize: 15,
            fontWeight: 700,
            cursor: "pointer",
            color: "#fff",
            background: "linear-gradient(90deg,#6366f1,#8b5cf6,#ec4899)",
            backgroundSize: "200% auto",
            animation: "cw-shimmerLt 4s linear infinite",
            boxShadow: "0 8px 25px rgba(99,102,241,0.4)",
            transition: "0.3s",
          }}
          onClick={() => alert("Payment gateway coming soon")}
        >
          Pay Now 
        </button>
      </div>
    </div>
  );
};

export default DoAndPayment;